import React from "react";

import Typography from "@mui/material/Typography";

import LINKS from "@app/common/links";

import Link from "@rui/Link";

import { BillingCard } from "./styles";

const BillingLoadFailure = () => (
  <BillingCard sx={{ borderColor: "error.main", p: 3, minHeight: "unset" }}>
    <Typography sx={{ color: "shades.neutral.800" }}>
      Oops! Something went wrong when trying to load your billing information.
      Please refresh the page or contact{" "}
      <Link href={LINKS.EMAIL.SUPPORT} sx={{ textDecoration: "underline" }}>
        support@read.ai
      </Link>{" "}
      if the problem persists.
    </Typography>
  </BillingCard>
);

export default BillingLoadFailure;
